<template>
  <div class="Abeoffice">
    <div class="Abeoffice_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">任职机构</div>
      <div class="determine" @click="ondetermine">确定</div>
    </div>
    <div class="Abeoffice_bottm">
      <van-cell-group inset style="margin: 0px 0px">
        <van-field
          required
          v-model="valuess"
          placeholder="请输入"
          label="机构名称"
          maxlength="20"
          center
        >
          <template #button>
            <van-button size="small" style="border: none"
              >{{ valuess.length }}/20</van-button
            >
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="value"
          placeholder="请输入"
          label="现任职位"
          maxlength="20"
          center
        >
          <template #button>
            <van-button size="small" style="border: none"
              >{{ value.length }}/20</van-button
            >
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="fieldValue"
          is-link
          readonly
          clickable
          name="picker"
          :value="value"
          label="选择省市"
          placeholder="请选择"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-cascader
            v-model="cascaderValue"
            title="请选择所在地区"
            :options="options"
            @close="showPicker = false"
            :field-names="fieldNames"
            @change="onChange"
            @finish="onFinish"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="text" placeholder="请输入" label="详细地址">
        </van-field>
      </van-cell-group>
      <van-cell-group inset>
        <van-field
          style="padding: 10px 0px"
          v-model="postCode"
          placeholder="请输入邮编"
          label="邮编"
        >
        </van-field>
      </van-cell-group>
      <van-cell-group inset>
        <van-checkbox class="check-box" v-model="defaultStatus"
          >默认</van-checkbox
        >
      </van-cell-group>
    </div>
  </div>
</template>
    
<script>
import { Toast } from "vant";
export default {
  name: "Abeoffice",
  data() {
    return {
      disabled: false,
      valuess: "",
      value: "",
      text: "",
      postCode: "",
      showPicker: false,
      cascaderValue: "",
      options: [],
      fieldValue: "",
      fieldNames: {
        text: "name",
        value: "code",
      },
      userInfo: "",
      // 省
      provinceName: "",
      province: "",
      // 市
      cityName: "",
      city: "",
      // 是否默认
      defaultStatus: false,
    };
  },
  created() {
    if (sessionStorage.getItem("subInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("subInfo"));
    } else {
      sessionStorage.setItem("subInfo", sessionStorage.getItem("subInfo"));
    }
    this.proLists();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.showPicker = false;
      this.fieldValue = selectedOptions.map((option) => option.name);
      this.province = selectedOptions[0].code;
      this.provinceName = selectedOptions[0].name;
      this.city = selectedOptions[1].code;
      this.cityName = selectedOptions[1].name;
    },
    // 省联调
    async proLists() {
      let res = await this.$apis.userServe.proList();
      res.content.provinceList.map((province) => {
        province.children = [{ code: "", name: "" }];
      });
      this.options = res.content.provinceList;
    },
    onChange({ value, selectedOptions, tabIndex }) {
      this.cityLists(value);
    },
    // 市联调
    async cityLists(value) {
      var index = this.options.findIndex((item) => {
        return item.code == value;
      });

      let res = await this.$apis.userServe.cityList({
        provinceCode: Number(value),
      });
      this.$set(this.options[index], "children", res.content.cityList);
    },
    // 点击确定
    ondetermine() {
      if (this.valuess == "") {
        Toast("机构名称不能为空");
      } else {
        if (this.defaultStatus) {
          this.userInfo.scholarPresentUnits.forEach((item) => {
            item.defaultStatus = false;
          });
        }
        this.userInfo.scholarPresentUnits.push({
          unitName: this.valuess,
          job: this.value,
          province: this.province,
          city: this.city,
          address: this.text,
          postCode: this.postCode,
          provinceName: this.provinceName,
          cityName: this.cityName,
          defaultStatus: this.defaultStatus,
        });
        sessionStorage.setItem("subInfo", JSON.stringify(this.userInfo));
        window.history.go(-1);
      }
    },
  },
};
</script>
    
<style lang="scss" scoped>
.Abeoffice {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .Abeoffice_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .Abeoffice_bottm {
    width: 94%;
    margin: 12px auto;
    background: #fff;
    border-radius: 8px;
  }

  .prompt {
    width: 94%;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    margin: 0 auto;
  }

  .check-box {
    // margin: 10px 0;
    height: 44px;
  }
}
</style>